import { EventEmitter, Injectable } from '@angular/core';

@Injectable()

export class TimerToLock {
    public readonly locked: EventEmitter<boolean> = new EventEmitter<boolean>();
    public time: any;
    public status: boolean;
    public constructor() {
        this.clear();
    }
    public clear() {
        clearTimeout(this.time);
        this.time = setTimeout(() => this.lock(),  30 * 60 * 1000 );
    }
    public lock() {
        console.log('ç³»ç»éå®');
        this.locked.emit(true);
        this.status = true;
    }
    public unlock() {
        this.locked.emit(false);
        this.status = false;
        this.clear();
    }

}
